// src/pages/Checkout.jsx
import React, { useEffect, useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  const navigate = useNavigate();

  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    pincode: "",
    city: "",
    state: "",
  });

  useEffect(() => {
    const bn = sessionStorage.getItem("kwicth_buy_now");
    if (bn) {
      const item = JSON.parse(bn);
      setCart([item]);
      setTotal(Number(item.price || 0) * (item.qty || 1));
    } else {
      const c = JSON.parse(localStorage.getItem("cart")) || [];
      setCart(c);
      const t = c.reduce((s, it) => s + Number(it.price) * (it.qty || 1), 0);
      setTotal(t);
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  function validate() {
    if (!form.name.trim()) return "Enter your name";
    if (!/^\d{10}$/.test(form.phone)) return "Enter 10-digit phone";
    if (!form.address.trim()) return "Enter address";
    if (!/^\d{5,6}$/.test(form.pincode)) return "Enter valid pincode";
    if (!form.city.trim()) return "Enter city";
    if (!form.state.trim()) return "Enter state";
    if (!cart.length) return "Cart is empty";
    return null;
  }

  // -----------------------------------------------
  // ONLINE PAYMENT
  // -----------------------------------------------
  async function handleOnlinePayment() {
    const err = validate();
    if (err) return alert(err);

    setLoading(true);

    // Razorpay script load
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    document.body.appendChild(script);

    script.onload = async () => {
      const options = {
        key: "rzp_live_RoLPhULDSZd9lh",
        amount: total * 100,
        currency: "INR",
        name: "KWICTH Store",
        description: "Order Payment",

        handler: async (response) => {
          try {
            const trackingId = "KW-" + Math.floor(100000 + Math.random() * 900000);

            const orderRef = await addDoc(collection(db, "orders"), {
              items: cart,
              total,
              status: "paid",
              trackingId,
              paymentId: response.razorpay_payment_id,
              customer: form,
              createdAt: serverTimestamp(),
            });

            localStorage.removeItem("cart");
            sessionStorage.removeItem("kwicth_buy_now");

            navigate(`/order-success?orderId=${orderRef.id}`);
          } catch (e) {
            alert("Order save failed!");
          }
        },

        prefill: {
          name: form.name,
          email: form.email,
          contact: form.phone,
        },

        theme: { color: "#111" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      setLoading(false);
    };

    script.onerror = () => {
      alert("Failed to load Razorpay script");
      setLoading(false);
    };
  }

  // -----------------------------------------------
  // CASH ON DELIVERY
  // -----------------------------------------------
  async function handleCOD() {
    const err = validate();
    if (err) return alert(err);

    try {
      const trackingId = "KW-" + Math.floor(100000 + Math.random() * 900000);

      const orderRef = await addDoc(collection(db, "orders"), {
        items: cart,
        total,
        status: "cod_pending",
        trackingId,
        customer: form,
        createdAt: serverTimestamp(),
      });

      localStorage.removeItem("cart");
      sessionStorage.removeItem("kwicth_buy_now");

      navigate(`/order-success?orderId=${orderRef.id}`);
    } catch (e) {
      alert("Order save failed!");
    }
  }

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 16 }}>
      <h2>Checkout</h2>

      <div style={{ border: "1px solid #eee", padding: 12, borderRadius: 8 }}>
        <h3>Order Summary</h3>

        {cart.length === 0 ? (
          <p>No items in cart.</p>
        ) : (
          <div>
            {cart.map((it, i) => (
              <div key={i}>
                {it.name} {it.size && `(${it.size})`} — ₹{it.price} × {it.qty}
              </div>
            ))}
            <p>
              <strong>Total: ₹{total}</strong>
            </p>
          </div>
        )}
      </div>

      <div style={{ marginTop: 20 }}>
        <label>
          Full Name
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </label>

        <label>
          Email
          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </label>

        <label>
          Phone
          <input
            name="phone"
            value={form.phone}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </label>

        <label>
          Address
          <textarea
            name="address"
            value={form.address}
            onChange={handleChange}
            style={{ width: "100%", padding: 8 }}
          />
        </label>

        <div style={{ display: "flex", gap: 8 }}>
          <input
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            placeholder="Pincode"
          />
          <input
            name="city"
            value={form.city}
            onChange={handleChange}
            placeholder="City"
          />
          <input
            name="state"
            value={form.state}
            onChange={handleChange}
            placeholder="State"
          />
        </div>

        <div style={{ marginTop: 18, display: "flex", gap: 12 }}>
          <button
            onClick={handleOnlinePayment}
            disabled={loading}
            style={{
              padding: "10px 14px",
              background: "#111",
              color: "#fff",
              borderRadius: 6,
            }}
          >
            Pay Online • ₹{total}
          </button>

          <button
            onClick={handleCOD}
            style={{
              padding: "10px 14px",
              border: "1px solid #111",
              borderRadius: 6,
            }}
          >
            Cash on Delivery
          </button>
        </div>
      </div>
    </div>
  );
}